import { useCookieConsent, useCookieConsentOptional } from "../../context/CookieConsentContext";
import CookiePreferencesModal from "./CookiePreferencesModal";
import { APP_NAME } from "../../util/brand";

export default function CookieConsentBanner() {
  const {
    bannerOpen,
    preferencesOpen,
    setPreferencesOpen,
    consent,
    acceptAll,
    rejectNonEssential,
    savePreferences,
    openPreferences,
  } = useCookieConsent();

  return (
    <>
      {bannerOpen && (
        <div
          className="fixed bottom-3 inset-x-3 sm:inset-x-auto sm:right-4 z-[10000]"
          role="region"
          aria-label="Cookie consent"
        >
          <div className="ml-auto max-w-xl rounded-xl border border-gray-200 bg-white shadow-2xl p-4 text-gray-900">
            <h2 className="text-base font-semibold mb-1.5">
              We value your privacy
            </h2>
            <p className="text-xs text-gray-600 leading-relaxed mb-3">
              We use cookies to run {APP_NAME}, provide support, and improve the service.
              Accept all, reject non-essential cookies, or customize your privacy choices. Read our{" "}
              <a href="/cookie-policy" className="underline text-blue-700">
                Cookie Policy
              </a>
              ,{" "}
              <a href="/privacy-policy" className="underline text-blue-700">
                Privacy Policy
              </a>
              , and{" "}
              <a href="/accessibility" className="underline text-blue-700">
                Accessibility Statement
              </a>
              .
            </p>
            <div className="flex flex-wrap gap-2">
              <button
                type="button"
                onClick={acceptAll}
                className="px-3.5 py-2 text-xs font-semibold rounded-lg bg-[#6847f5] text-white hover:bg-[#5938df] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#6847f5] focus-visible:ring-offset-2"
              >
                Accept all
              </button>
              <button
                type="button"
                onClick={rejectNonEssential}
                className="px-3.5 py-2 text-xs font-semibold rounded-lg border border-gray-300 text-gray-800 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#6847f5] focus-visible:ring-offset-2"
              >
                Reject non-essential
              </button>
              <button
                type="button"
                onClick={openPreferences}
                className="px-3.5 py-2 text-xs font-semibold rounded-lg border border-gray-300 text-gray-800 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#6847f5] focus-visible:ring-offset-2"
              >
                Customize
              </button>
            </div>
          </div>
        </div>
      )}

      <CookiePreferencesModal
        open={preferencesOpen}
        onClose={() => setPreferencesOpen(false)}
        initial={consent}
        onSave={savePreferences}
      />
    </>
  );
}

/** Footer / in-page link to reopen preferences */
export function CookieSettingsLink({ className = "" }) {
  const ctx = useCookieConsentOptional();
  if (!ctx) {
    return (
      <a href="/cookie-policy" className={className}>
        Cookie settings
      </a>
    );
  }
  return (
    <button
      type="button"
      onClick={ctx.openPreferences}
      className={
        className ||
        "underline text-inherit bg-transparent border-0 p-0 cursor-pointer font-inherit"
      }
    >
      Cookie settings
    </button>
  );
}
